var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-table',{attrs:{"url":"/api/v1/blacklistUsername","attributes":[
      {
        attribute: 'name',
        name: 'Name',
        type: 'InputCell',
        message: 'Der Name wurde gespeichert',
        url: 'update_url'
      },
      {
        attribute: 'created_by.name',
        name: 'Erstellt von'
      },
      {
        attribute: 'created_at',
        name: 'Erstellt um',
        type: 'DateTimeCell'
      },
      {
        attribute: 'updated_by.name',
        name: 'Updated von'
      },
      {
        attribute: 'updated_at',
        name: 'Updated um',
        type: 'DateTimeCell'
      },
      {
        notification: 'Der name wurde aus der Blacklist gelöscht',
        name: 'Entfernen',
        type: 'DeleteCell',
        label: 'Löschen',
        sortable: false
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Namen bearbeiten")])])]),_vm._v(" "),_c('resource',{attrs:{"resource":"blacklistUsername","resourceName":"Blacklist","attributes":_vm.attributes},on:{"resource-persisted":function($event){return _vm.$bus.$emit('refresh-table')}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Namen hinzufügen")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }